import type { BeaconRenderProps } from 'react-joyride';

import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

type TutorialBeacon = BeaconRenderProps & {
  step: BeaconRenderProps['step'] & { testId?: string };
};

const TutorialBeacon = ({ step, index = 0 }: TutorialBeacon) => {
  return (
    <div {...getTestProps(step?.testId || `floater-beacon-${index}`)}>
      <div
        className={twMerge(
          'w-8 h-8 rounded-full bg-[#f3b5375c]',
          'animate-pulse border-solid border-2 border-orange',
        )}
      />
      <div
        className={twMerge(
          'absolute top-2 right-2',
          'w-4 h-4 rounded-full bg-orange',
        )}
      />
    </div>
  );
};

export default TutorialBeacon;
